import background1 from "../assets/image/background/background1.webp";
import background2 from "../assets/image/background/background2.webp";
import background3 from "../assets/image/background/background3.webp";
import background4 from "../assets/image/background/background4.webp";
import background5 from "../assets/image/background/background5.webp";
import logo from "../assets/image/logo.png";
import fevicon from "../assets/image/fevicon.png";
import error from "../assets/image/errors.svg";
import header_bg from "../assets/image/engine/header_bg.jpg";

import user from "../assets/icons/user.png";
import lunch from "../assets/icons/lunch.png";
import dinner from "../assets/icons/dinner.png";
import breakfast from "../assets/icons/breakfast.png";

import walkIn from "../assets/image/segments/walk_in.png";
import agoda from "../assets/image/segments/agoda.png";
import bookingcom from "../assets/image/segments/bookingcom.png";
import booking_engine from "../assets/image/segments/booking_engine.png";
import corporate from "../assets/image/segments/corporate.png";
import makemytrip from "../assets/image/segments/makemytrip.png";
import ota from "../assets/image/segments/ota.png";
import travel_agency from "../assets/image/segments/travel_agency.png";
import others from "../assets/image/segments/others.png";
import expedia from "../assets/image/segments/expedia.png";
import goibibo from "../assets/image/segments/goibibo.png";
import airbnb from "../assets/image/segments/airbnb.png";

import userProfile from "../assets/image/segments/user.png";

import notification from "../assets/audio/notification.mp3";
export const notification_sound = notification;

// Export the backgrounds and logo
const assets = {
  backgrounds: [
    background1,
    background2,
    background3,
    background4,
    background5,
  ],
  logo,
  fevicon,
  error,
  header_bg,
  user,
  lunch,
  dinner,
  breakfast,

  walkIn,
  agoda,
  bookingcom,
  booking_engine,
  corporate,
  makemytrip,
  ota,
  travel_agency,
  expedia,
  goibibo,
  airbnb,
  others,

  userProfile,
};

export default assets;
